import ImageCompare from 'image-compare-viewer';
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

document.addEventListener("DOMContentLoaded", () => {
    const viewers = document.querySelectorAll(".image-compare-selector");

    viewers.forEach((element) => {
        // Create options dynamically for each element
        const options = {
            // UI Theme Defaults
            controlColor: element.getAttribute('data-slider-devider-color') === 'white' ? 'white' : 'black',
            controlShadow: true,
            addCircle: false,
            addCircleBlur: true,

            // Label Defaults
            showLabels: true,
            labelOptions: {
                before: element.getAttribute('data-slider-text-left') || 'Before',
                after: element.getAttribute('data-slider-text-right') || 'After',
                onHover: false
            },

            // Smoothing
            smoothing: true,
            smoothingAmount: 300,

            // Other options
            hoverStart: false,
            verticalMode: element.getAttribute('data-slider-alignment') !== 'vertical',
            startingPoint: 50,
            fluidMode: true,
        };
        new ImageCompare(element, options).mount();

        element.addEventListener("mousedown", (ev) =>{
            enableBodyScroll(element);
        })
        element.addEventListener("mouseup", (ev) =>{
            enableBodyScroll(element);
        })
        // Calculate aspect ratio from first image
        const firstImage = element.querySelector('#image-compare img');
        if (firstImage) {
            const img = new Image();
            img.onload = () => {
                element.style.aspectRatio = img.width / img.height;
                element.style.width = '100%';
            };
            img.src = firstImage.src;
        }
    });
});